import { getProgressStateFromPageIndex } from "../utils";

import { PageIndex } from "./types";

const startPageIndex = 0 as PageIndex;

export const initialState = {
  pageIndex: startPageIndex,
  progressState: getProgressStateFromPageIndex(startPageIndex, undefined),
  data: {
    todo: "",
  },
};
